export default __webpack_public_path__ + "static/anniversary-logo-38a39d62dd6de69620d4b3c1ef97c0a3.svg";